export default {
  en: {
    /** Mypage Bookmark List */
    MypageBookmarkList: {
      noBookmarks: 'There are no bookmarks',
      rows10: '10 rows',
      rows25: '25 rows',
      rows50: '50 rows',
      summaryHead: 'Page title',
      date: 'Date'
    },
    /** Mypage DownloadHistory */
    MypageDownloadHistory: {
      text1: 'Up to 50 recently downloaded items are displayed.',
      text2:
        'Downloaded items are saved in your history for 1 year. After this time they will no longer be listed here.',
      noHistory: 'There is no download history.',
      summaryHead: 'Title',
      attributeHead1: 'Content type',
      attributeHead2: 'File type',
      date: 'Download Date'
    },
    /** Mypage DonwloadHistory Top */
    MypageTopDownloadHistory: {
      top: 'Up to 50 pages can be added to the Bookmarks list.',
      text: 'View Bookmarks',
      title: 'Your latest download history'
    }
  },
  'zh-hant': {
    /** Mypage Bookmark List */
    MypageBookmarkList: {
      noBookmarks: '您沒有收藏的頁面',
      rows10: '10行',
      rows25: '25行',
      rows50: '50行',
      summaryHead: '頁面標題',
      date: '日期'
    },
    /** Mypage DownloadHistory */
    MypageDownloadHistory: {
      text1: '最多顯示 50 個最近下載的項目。',
      text2:
        '下載的項目會在您的歷史記錄中保存 1 年。在此之後，它們將不會在此處列出。',
      noHistory: '您沒有下載資料的歷史紀錄。',
      summaryHead: '標題',
      attributeHead1: '內容類型',
      attributeHead2: '文件類型',
      date: '下載日期'
    },
    /** Mypage DonwloadHistory Top */
    MypageTopDownloadHistory: {
      top: '最多可新增50個收藏頁面。',
      text: '查閱收藏頁面',
      title: '您的最近下載紀錄'
    }
  },
  ja: {
    /** Mypage Bookmark List */
    MypageBookmarkList: {
      noBookmarks: 'ブックマークはありません',
      rows10: '10行',
      rows25: '25行',
      rows50: '50行',
      summaryHead: 'ページタイトル',
      date: '日付'
    },
    /** Mypage DownloadHistory */
    MypageDownloadHistory: {
      text1: '最近ダウンロードしたアイテムを最大 50 個まで表示',
      text2:
        'ダウンロードしたアイテムは、1 年間履歴に保存されます。 この時間以降、それらはここにリストされなくなります。',
      noHistory: 'ダウンロード履歴がありません。',
      summaryHead: 'タイトル',
      attributeHead1: '種別',
      attributeHead2: 'ファイル種別',
      date: 'ダウンロード日'
    },
    /** Mypage DonwloadHistory Top */
    MypageTopDownloadHistory: {
      top: 'ブックマークリストに最大 50 ページを追加できます。',
      text: 'ブックマークを表示',
      title: '最新のダウンロード履歴'
    }
  },
  es: {
    /** Mypage Bookmark List */
    MypageBookmarkList: {
      noBookmarks: 'No hay marcadores',
      rows10: '10 filas',
      rows25: '25 filas',
      rows50: '50 filas',
      summaryHead: 'Título de la página',
      date: 'Fecha'
    },
    /** Mypage DownloadHistory */
    MypageDownloadHistory: {
      text1: 'Se muestran hasta 50 elementos descargados recientemente.',
      text2:
        'Los elementos descargados se guardan en su historial durante 1 año. Después de este tiempo, ya no aparecerán aquí.',
      noHistory: 'No hay historial de descargas.',
      summaryHead: 'Título',
      attributeHead1: 'Tipo de contenido',
      attributeHead2: 'Tipo de archivo',
      date: 'Fecha de descarga'
    },
    /** Mypage DonwloadHistory Top */
    MypageTopDownloadHistory: {
      top: 'Se pueden agregar hasta 50 páginas a la lista de marcadores.',
      text: 'Ver marcadores',
      title: 'Tu historial de descargas más reciente'
    }
  },
  'pt-br': {
    /** Mypage Bookmark List */
    MypageBookmarkList: {
      noBookmarks: 'Não há favoritos',
      rows10: '10 linhas',
      rows25: '25 linhas',
      rows50: '50 linhas',
      summaryHead: 'Título da página',
      date: 'Data'
    },
    /** Mypage DownloadHistory */
    MypageDownloadHistory: {
      text1: 'Os últimos 50 itens baixados são exibidos.',
      text2:
        'Os itens baixados são salvos em seu histórico por 1 ano. Após esse período, eles não serão mais listados aqui.',
      noHistory: 'Não há histórico de download.',
      summaryHead: 'Título',
      attributeHead1: 'Tipo de conteúdo',
      attributeHead2: 'Tipo de arquivo',
      date: 'Data de download'
    },
    /** Mypage DonwloadHistory Top */
    MypageTopDownloadHistory: {
      top: 'Até 50 páginas podem ser adicionadas à lista de favoritos.',
      text: 'Exibir favoritos',
      title: 'Histórico de download mais recente'
    }
  }
}
